import { ContainerActions } from '../../interface';
import { AppAction } from './enum';
import {
    AppError,
    AppState,
} from './interface';

/**
 * Loads initial state and triggers init sagas
 */
export const initStore = (state: Partial<AppState>) => ({
    type: AppAction.InitStore,
    state,
} as const);

/**
 * Starts the loading state for ID of action
 */
export const startLoading = (id: ContainerActions) => ({
    type: AppAction.StartLoading,
    id,
} as const);

/**
 * Stops the loading state for ID of action
 */
export const stopLoading = (id: ContainerActions) => ({
    type: AppAction.StopLoading,
    id,
} as const);

/**
 * Sets the given error into the state
 */
export const setError = (error: AppError) => ({
    type: AppAction.SetError,
    error,
} as const);

/**
 * Sets the given level ID into the state
 */
export const stepToNextLevel = (levelId: string) => ({
    type: AppAction.StepToNextLevel,
    levelId,
} as const);

/**
 * Sets the current level to the previous one
 */
export const stepToPrevLevel = () => ({
    type: AppAction.StepBack,
} as const);

/**
 * Type for all actions
 */
export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof startLoading>
    | ReturnType<typeof stopLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof stepToNextLevel>
    | ReturnType<typeof stepToPrevLevel>;
